module.exports = __webpack_public_path__ + "static/media/gb-eng.eabfeadc.svg";